<script setup lang="ts">
import IpAllowListManager from '@/modules/common/components/IpAllowListManager.vue';

defineProps<{ companyId: string }>();

const emit = defineEmits<{ (e: 'update:company-id', companyId: string | null): void }>();

function closeDialog(): void {
  emit('update:company-id', null);
}
</script>

<template>
  <VDialog
    v-shortkey="['esc']"
    content-class="au-popup-dialog"
    max-width="600"
    overlay-color="secondary"
    overlay-opacity="0.25"
    transition="scale-transition"
    :value="true"
    @click:outside="closeDialog()"
    @keydown.esc="closeDialog()"
    @shortkey.native="closeDialog()"
  >
    <VCard class="d-flex flex-column">
      <VCardTitle>
        <span class="headline">Manage IP Range Allow List</span>
        <VBtn class="close-icon" icon @click="closeDialog()">
          <VIcon>mdi-close</VIcon>
        </VBtn>
      </VCardTitle>
      <VCardText>
        <VContainer>
          <VRow>
            <VCol class="pa-0" cols="12">
              <IpAllowListManager :company-id="companyId" />
            </VCol>
          </VRow>
        </VContainer>
      </VCardText>
    </VCard>
  </VDialog>
</template>

<style lang="scss" scoped>
.close-icon {
  top: 0.4rem;
  right: 0.4rem;
  position: absolute;
}
</style>
